module.exports = __webpack_public_path__ + "static/media/GEOMATICA_8.0ac1785f.png";